import cleanedFilename from '~/util/cleanedFilename';

export default {
  VALUE_REPORT_DROPDOWN: `${cleanedFilename(__filename)}-value-report-dropdown`,
};
